<template>
  <b-card>
    <h4 class="mb-2">Ajouter un nouveau client</h4>

    <b-alert
        v-if="error"
        dismissible
        show
        variant="danger"
    >
      {{ error }}
    </b-alert>

    <client-edit-tab-information
        :client="newClient"
        :loading="loading"
        @submit="createClient"
    />
  </b-card>
</template>

<script>
import {mapState} from 'vuex'
import ClientsEditClientTabInformation from './clients-edit/ClientsEditClientTabInformation.vue'
import {BAlert, BCard} from "bootstrap-vue";

export default {
  components: {
    BAlert,
    BCard,
    ClientEditTabInformation: ClientsEditClientTabInformation,
  },
  data() {
    return {
      newClient: {
        name: '',
        type: 'company',
        details: {
          contact_person: '',
          email: '',
          phone: '',
          address: '',
        },
        notes: '',
        country: null,
      },
      error: null,
    }
  },
  computed: {
    ...mapState('client', ['loading']),
  },
  methods: {
    async createClient(clientData) {
      try {
        const client = await this.$store.dispatch('client/addClient', clientData)

        this.$toast({
          component: 'b-toast',
          props: {
            title: 'Succès',
            variant: 'success',
            content: 'Client créé avec succès',
          },
        })

        this.$router.push({
          name: 'apps-client-view',
          params: {id: client.id}
        })
      } catch (error) {
        console.log({...error})
        this.error = "Erreur lors de la création du client."
      }
    },
  },
}
</script>